import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Input, Button, Alert, Spinner } from 'reactstrap';
import Accordion, { AccordionItem, AccordionHeader, AccordionBody } from '../../components/Accordion';
import Telefone from '../../components/Telefone';

import actions from './actions';

class ListaContatos extends Component {
  constructor (props) {
    super(props);

    this.state = {
      pesquisa: '',
      delayedPesquisa: ''
    };

    this.pesquisaContato = this.pesquisaContato.bind(this);
  }

  componentDidMount () {
    this.props.actions.onLoadListaContatos();
  }

  componentWillUnmount () {
    clearTimeout(this.delayedState);
  }

  pesquisaContato (e) {
    let pesquisa = e.target.value.toUpperCase();

    this.setState({
      pesquisa
    });

    clearTimeout(this.delayedState);
    this.delayedState = setTimeout(() => {
      this.setState({
        delayedPesquisa: pesquisa
      });
    }, 400);
  }

  render() {
    let { pesquisa, delayedPesquisa } = this.state;
    let { value: { fetching, result } } = this.props;

    return (
      <div>
        <Input placeholder="Pesquisar contato..." value={pesquisa} onChange={this.pesquisaContato} />
        <br />
        {1 === fetching && <Alert fade={false} color="dark"><Spinner size="sm" color="dark" /> Obtendo lista de contatos...</Alert>}
        <ResultadoPesquisa search={delayedPesquisa} value={result} />
        <br />
        * Para alterar os dados acima, contate a Administradora.
      </div>
    );
  }
}

const ResultadoPesquisa = ({search, value}) => (
<Accordion>
  {value.map(unidade => unidade.contatos.filter(contato => !search || -1 < ([unidade.unidade, contato.nome, contato.emails.join(','), contato.telefones.map(v => v.numero).join(',')].join(',')).indexOf(search)).map((contato, i) => {
    let telefone = contato.telefones[0];
    let email = contato.emails.join(',');
    return (
      <AccordionItem key={i} id={contato.id + "-" + unidade.unidade}>
        <AccordionHeader className="d-flex justify-content-between align-items-center">{unidade.unidade} {contato.nome}<div className="text-right">
          {email && <Button size="sm" onClick={e => e.stopPropagation()} tag="a" href={"mailto:" + email}>
            <span className="fa fa-envelope" />{' '}
            <span className="d-none d-sm-inline-block">
              E-mail
            </span>
          </Button>}
          {telefone && <Button color="success" size="sm" onClick={e => e.stopPropagation()} tag="a" href={"tel:+" + telefone.ddi + telefone.ddd + telefone.numero}>
            <span className="fa fa-phone" />{' '}
            <span className="d-none d-sm-inline-block">
              Telefone
            </span>
          </Button>}
        </div></AccordionHeader>
        <AccordionBody>
          <ul>
            {contato.emails.map((v, i) => (<li key={i}><a href={"mailto:" +v}>{v}</a></li>))}
          </ul>
          <ul>
            {contato.telefones.map((v, i) => (<li key={i}><Telefone>{v}</Telefone></li>))}
          </ul>
        </AccordionBody>
      </AccordionItem>
    );
  }))}
</Accordion>);

let mapStateToProps = ({ admin: { contatos } }) => ({
  value: contatos
});

let mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ListaContatos);



// WEBPACK FOOTER //
// ./src/modules/admin/ListaContatos.js